'use strict';

import fitvids from 'fitvids';
import * as dom from './lib/dom.js';

	function responsiveVideos() {
		const singleEl = document.querySelector('.single');
        const displayWidth = window.innerWidth;

		if(displayWidth < 1024) {
			if (singleEl) {
				fitvids('.c-content-shield__main', {
	                players: ['iframe[src*="soundcloud.com"]']
	            });
			}
		} else {
			fitvids('.c-content-shield__main'); 
		}
	}

export default function(){
	window.addEventListener('load', function() {
       responsiveVideos();
	})
}
 